import ContactForm from "../components/contact-form";
import { Phone, Mail } from "lucide-react";

import "./contact.css";
import ContactSeo from "../components/seo/contact-seo";
export default function Contact() {
	return (
		<div className="contact-page">
			<ContactSeo description="Get in touch with Heron Lane Farm in Whatcom County, WA. Reach out to order lamb, ask about 4H and FFA projects, or learn more about our farm." />
			<div className="contact-intro-panel panel">
				<h3>Contact Us</h3>
				<div>
					We have a limited amount of meat available each year, please contact
					us ASAP if you are interested, or to join the waitlist.
				</div>
			</div>
			<div className="contact-options-container">
				<div className="contact-info panel">
					<h3>Contact Information</h3>
					<div className="contact-info-item">
						<Mail size={24} className="contact-icon green" />
						<a
							href="mailto:graceinsumas@gmail.com"
							className="contact-info email"
						>
							graceinsumas@gmail.com
						</a>
					</div>
					<div className="contact-info-item">
						<Phone size={24} className="contact-icon green" />
						<a href="tel:3609277748" className="contact-info phone">
							360-927-7748
						</a>
					</div>
				</div>
				<div className="contact-form">
					<ContactForm />
				</div>
			</div>
		</div>
	);
}
